import React from 'react';
import {useNode} from '@craftjs/core';
import {useEditorStyle} from 'hooks';
import {ColorPicker, Divider} from 'components';
import {formatColorResult} from 'utils';

import EditorInspectorPadding from '../../inspectors/Editor.Inspector.Padding';
import EditorInspectorMargin from '../../inspectors/Editor.Inspector.Margin';

interface IEditorInspectorLauncherProps {}

const EditorInspectorLauncher = ({}: IEditorInspectorLauncherProps) => {
  const {
    actions: {setProp},
  } = useNode();

  const {device, style, updateStyle} = useEditorStyle({setProp});

  return (
    <div key={device}>
      <h4 className="text-slate-800 dark:text-white font-semibold">Launcher</h4>
      <Divider />
      {(() => {
        if (device === 'desktop') {
          return <p>This component is only for mobile view.</p>;
        }
        return (
          <>
            <div className="flex items-center justify-between">
              <p className="text-sm">Background</p>
              <ColorPicker
                alignment="right"
                color={style?.backgroundColor ?? 'white'}
                onPicked={color => {
                  updateStyle('backgroundColor', formatColorResult(color));
                }}
              />
            </div>
            <Divider />
            <EditorInspectorPadding style={style} setProp={setProp} />
            <Divider />
            <EditorInspectorMargin style={style} setProp={setProp} />
          </>
        );
      })()}
    </div>
  );
};

export default React.memo(EditorInspectorLauncher);
